import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal, Row, Col, Typography, Upload, notification, Icon } from 'antd';
import { Grid, Card } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import MainContainer from '../../../components/MainContainer';
import TemplateList from './TemplateList';
import TemplateUpdate from './TemplateUpdate';
import ApiCaller from '../../../utils/api-caller';

const { Text } = Typography;

@inject(
    'loginStore',
    'templateStore'
)
@observer
class TemplatePage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            uploadingTemplate: false
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
    
        this.props.templateStore.initTemplate();
    }

    componentWillUnmount() {
        this.props.templateStore.setShowUpdateTemplateModal(false);
    }

    handleCancelUpdateTemplateModal = () => {
        this.props.templateStore.setShowUpdateTemplateModal(false);
    }

    handleCancelSearchMenuIteModal = () => {
        this.props.templateStore.setShowSearchMenuItemModal(false);
    }

    // ON UPLOAD

    dummyTemplateRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 0);
    }

    beforeUploadTemplate = (file) => {
        const { t } = this.props;
        const isJson = file.type === 'application/json';
        if (!isJson) {
            notification.warning({
                message: t('Failed to upload file'),
                description: t('You can only upload JSON file!'),
                placement: 'bottomRight',
            });
        }

        const isLessThan10Mb = file.size / 1024 / 1024 <= 1;
        if (!isLessThan10Mb) {
            notification.warning({
                message: t('Failed to upload file'),
                description: t('File must smaller or equal to 1MB!'),
                placement: 'bottomRight',
            });
        }

        if (isJson && isLessThan10Mb) {
            this.setState({ uploadingTemplate: true });
        }

        return isJson && isLessThan10Mb;
    }

    uploadTemplateOnChange = (info) => {
        const { t } = this.props;
        if (info.file.status) {
            if (info.file.status === 'uploading') {
                return;
            }

            if (info.file.status === 'done') {
                ApiCaller.Imports.template(info.file.originFileObj).then(resp => {
                    this.setState({ uploadingTemplate: false });

                    if (!resp.isError) {
                        this.props.templateStore.initTemplate();
                        notification.success({
                            message: t('Success'),
                            description: t('Template has been successfully imported.'),
                            placement: 'topRight',
                        });
                    } else {
                        notification.error({
                            message: t('Error'),
                            description: t('Failed to import Template. Error Messages = {{message}}', { message: resp[0].errorMessage }),
                            placement: 'topRight',
                        });
                    }
                })
            }
        }
    }

    render() {
        const { t } = this.props;
        const {
            showUpdateTemplateModal,
            manageTemplateTitle
        } = this.props.templateStore;

        const uploadTemplateButton = (
            <div>
                {
                    this.state.uploadingTemplate
                        ?
                        <React.Fragment>
                            <Icon className='importItemLanguage-icon-upload' type='loading' />
                            <div className='importItemLanguage-div-upload'>{t('Importing Template......')}</div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <Icon className='importItemLanguage-icon-upload' type='plus' />
                            <div className='importItemLanguage-div-upload'>{t('Import Template')}</div>
                        </React.Fragment>
                }
            </div>
        );

        return (
            <MainContainer title={t('Template Management')} menukey='template'>
                <Modal
                    title={t(manageTemplateTitle)}
                    visible={showUpdateTemplateModal}
                    width={'80%'}
                    footer={null}
                    onCancel={this.handleCancelUpdateTemplateModal}
                    zIndex={1000}
                >
                    <TemplateUpdate />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card>
                            <Row className='importItemLanguage-row-container'>
                                <Col span={24} className='importItemLanguage-col-label'>
                                    <Text className='importItemLanguage-text-label'>{t('Import Template')}</Text><br />
                                    <Text className='importItemLanguage-text-label-detail'>{t('Your file must be JSON')}</Text>
                                </Col>
                                <Col span={24} className='importItemLanguage-col-input'>
                                    <Upload
                                        listType='picture-card'
                                        className='avatar-uploader'
                                        showUploadList={false}
                                        customRequest={this.dummyTemplateRequest}
                                        beforeUpload={this.beforeUploadTemplate}
                                        onChange={(info) => this.uploadTemplateOnChange(info)}
                                    >
                                        {uploadTemplateButton}
                                    </Upload>
                                </Col>
                            </Row>
                        </Card>
                        <Card style={{ minHeight: 500, padding: 20, overflow: 'auto', marginTop: 16 }}>
                            <TemplateList />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(TemplatePage);